module.exports = __webpack_public_path__ + "img/e_3_12_g.8572920d.png";